import React, { useEffect, useRef, useState } from "react";
import { Box } from "@mui/material";

import EstimateSummary from "./EstimateSummary";
import PillarAccordion from "./PillarAccordion";
import { ENGLISH_PILLARS, MATH_PILLARS } from "../../../data/pillars";

const SectionView = ({
  section,
  analytics,
  pillarEstimates,
  estimateHistory,
}) => {
  const PILLARS = section === "English" ? ENGLISH_PILLARS : MATH_PILLARS;

  const [openPillarId, setOpenPillarId] = useState(null);
  const [bottomSpacerHeight, setBottomSpacerHeight] = useState(0);

  useEffect(() => {
    if (!openPillarId) {
      setBottomSpacerHeight(0);
      return;
    }

    const el = document.getElementById(`pillar-${openPillarId}`);
    if (!el) return;

    const viewportHeight = window.innerHeight;
    const rect = el.getBoundingClientRect();

    /**
     * If the accordion is shorter than the viewport,
     * add spacer so scrollIntoView doesn't overshoot
     */
    const neededSpace = Math.max(
      0,
      viewportHeight - rect.height // header + breathing room
    );

    setBottomSpacerHeight(neededSpace);

    // Let layout settle before scrolling
    requestAnimationFrame(() => {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  }, [openPillarId]);

  return (
    <Box>
      <EstimateSummary
        section={section}
        pillars={PILLARS}
        pillarEstimates={pillarEstimates}
        estimateHistory={estimateHistory}
        onSelectPillar={setOpenPillarId}
      />

      <Box sx={{ mt: 4 }}>
        {PILLARS.map((pillar) => (
          <PillarAccordion
            key={pillar.id}
            pillar={pillar}
            section={section}
            analytics={analytics}
            open={openPillarId === pillar.id}
            onToggle={() =>
              setOpenPillarId((prev) =>
                prev === pillar.id ? null : pillar.id
              )
            }
          />
        ))}

        {/* Dynamic spacer to prevent overscroll */}
        {bottomSpacerHeight > 0 && (
          <Box sx={{ height: bottomSpacerHeight }} />
        )}
      </Box>
    </Box>
  );
};

export default SectionView;
